import axios, { AxiosRequestConfig } from 'axios';
import { authProvider } from '../../authProvider';
import { Guid } from 'guid-typescript';

export const baseURL = process.env.REACT_APP_URL_BASE_API;
export const api = axios.create({baseURL});

api.interceptors.response.use(
  (response) => {return response;},
  (error) => {return Promise.reject(error);}
);

async function get(endpoint: string) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});

  const config = 
  {
    headers: 
    {
      'content-type': 'application/json',
      Authorization: `Bearer ${token.idToken.rawIdToken}`,
      'correlationId': Guid.create(),
      'idUsuario': encodeURIComponent(`${token.idToken.name}`)
    }
  } as AxiosRequestConfig;

  return api.get(endpoint, config).catch((error) => console.log(error));
}

async function post(endpoint: string, params: any, config?: AxiosRequestConfig)
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});
  const correlationId = Guid.create().toString();

  let configCompleto =
  {
        headers:
        {
          'content-type': 'application/json',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': correlationId,
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
        }
      } as AxiosRequestConfig;

  configCompleto.headers = {...configCompleto.headers, ...config?.headers}

  return api.post(endpoint, params, configCompleto).catch((error) => {
    error.correlationId = correlationId;
    throw error;
  });
}

async function put(endpoint: string, params: any) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});

  const config = 
  {
    headers: 
    {
          'content-type': 'application/json',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': Guid.create().toString(),
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
    }
  } as AxiosRequestConfig;

  return api.put(endpoint, params, config).catch((error) => console.log(error));
}

async function getBlob(endpoint: string) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});

  return api
    .get(endpoint, 
      {
        responseType: 'blob',
        headers: 
        {
          'Accept': 'application/octet-stream',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': Guid.create().toString(),
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
        }
      }).catch((error) => console.log(error));
}

async function getZip(endpoint: string) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});
  
  return api
    .get(endpoint, 
      {
        responseType: 'blob',
        headers: 
        {
          'Accept': 'application/zip',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': Guid.create().toString(),
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
        }
      });
}

async function getFiltro(endpoint: string) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});

  return api
    .get(endpoint, 
      {
      responseType: 'json',
        headers: 
        {
          'Accept': 'Client.get',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': Guid.create().toString(),
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
        }
      });
}

async function getParametro(endpoint: string, params: any) 
{
  const token = await authProvider.acquireTokenSilent({scopes: ["openid"]});

  return api
    .get(endpoint, 
      {
        responseType: 'json',
        headers: 
        {
          'Accept': 'Client.get',
          Authorization: `Bearer ${token.idToken.rawIdToken}`,
          'correlationId': Guid.create().toString(),
          'idUsuario': encodeURIComponent(`${token.idToken.name}`)
        },params
      });
}

export default 
{
  get,
  post,
  put,
  getBlob,
  getZip,
  getFiltro,
  getParametro
};
